<template>
    <label v-if="hasSelectOptions" :for="id" class="small is-block">Anrede*</label>
    <div v-if="hasSelectOptions" class="select">
        <select :id="id" required :value="salutation" @change="$emit('update:salutation', $event.target.value)">
            <option disabled value="">Bitte auswählen</option>
            <option v-for="salutation in salutationOptions" :key="salutation" :value="salutation">
                {{ salutation }}
            </option>
        </select>
    </div>
</template>

<script>

export default {
    name: 'RegisterFormPartSalutation',
    props: {
        id: String,
        salutationOptions: Array,
        salutation: String,
    },
    computed: {
        hasSelectOptions() {
            return this.salutationOptions && Array.isArray(this.salutationOptions) && this.salutationOptions.length > 0;
        },
    },
    emits: [
        'update:salutation',
    ],
}
</script>
